<template>
	<aside class="cart-box">
		<div class="cart-box-body">
			<div class="cart-box-total">
				<div class="cart-box-id wcb-box-totals">
					<BaseCmsLabel code="order_id" />:
					<span v-if="additionalPaymentRoute == 1 && additionalPayment">{{ additionalPayment.cart.order_id }}</span>
					<span v-else-if="orderData && orderData.cart">{{ orderData.cart.order_id }}</span>
				</div>
				<div class="cart-box-totals wcb-box-totals">
					<BaseCmsLabel code="payment_second_form_total" />:
					<span v-if="additionalPaymentRoute == 1 && additionalPayment"><BaseUtilsFormatCurrency :price="additionalPayment.total.total" /></span>
					<span v-else-if="orderData && orderData.total"><BaseUtilsFormatCurrency :price="orderData.total.total" /></span>
				</div>
				<div class="cart-box-note">
					<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="bankart_payment_info_additpayment" /></template>
					<template v-else><BaseCmsLabel code="bankart_payment_info" /></template>
				</div>
			</div>

			<button v-if="checkoutLoading || creation" class="btn btn-green btn-cart-box btn-icon-arrow btn-submit btn-spinner"></button>
			<div v-else-if="(!meta?.valid || !formValid) || orderData?.cart?.can_change_payment == false" class="btn btn-green btn-cart-box btn-submit btn-disabled">
				<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="confirm_payment_additpayment" /></template>
				<template v-else-if="props.mode == 'newPaymentMode'"><BaseCmsLabel code="confirm_new_payment" /></template>
				<template v-else><BaseCmsLabel code="paid" /></template>
				<span v-if="(!meta?.valid || !formValid) || orderData?.cart?.can_change_payment == false" class="wc-box-btn-note"><BaseCmsLabel code="wc_next_step_note" /></span>
			</div>
			<button v-else class="btn btn-green btn-cart-box btn-submit" type="submit">
				<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="confirm_payment_additpayment" /></template>
				<template v-else-if="props.mode == 'newPaymentMode'"><BaseCmsLabel code="confirm_new_payment" /></template>
				<template v-else><BaseCmsLabel code="paid" /></template>
			</button>
			<div
				v-if="props.mode == 'newPaymentMode'"
				@click="cancelOrder()"
				:disabled="orderData && orderData.cart?.can_change_payment == false"
				class="btn btn-white btn-cart-box btn-icon-arrow btn-canceled-order"
				:class="{'btn-disabled' : orderData && orderData.cart?.can_change_payment == false}">
				<span v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="cancel_order_additpayment" /></span>
				<span v-else><BaseCmsLabel code="cancel_order" /></span>
			</div>
			<div v-else @click="newPaymentFunction()" class="btn btn-white btn-cart-box btn-icon-arrow btn-canceled">
				<span><BaseCmsLabel code="canceled" /></span>
			</div>
		</div>
	</aside>
</template>

<script setup>
	const webshop = useWebshop();
	const apiRoutes = useApiRoutes();
	const endpoints = useEndpoints();
	const labels = useLabels();
	const {emit} = useEventBus();
	const props = defineProps({
		mode: {
			type: String,
			default: '',
		},
		meta: Object,
		review: {
			type: null,
			default: false,
		},
		invalidSubmitNote: {
			type: null,
			default: false,
		},
	});

	const { creation, checkoutLoading, orderSuccess, newPayment, newPaymentOptions, newPaymentId, newPaymentCard, newPaymentInstallment, formValid, additionalPayment, additionalPaymentRoute, orderData } = useCheckout();

	async function cancelOrder() {
		checkoutLoading.value = true;

		const id_code = (additionalPaymentRoute.value == 1) ? additionalPayment.value.cart.id + '-' + additionalPayment.value.cart.code : orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
		const webshopOrderId = (additionalPaymentRoute.value == 1) ? endpoints.get('_put_hapi_webshop_additionalpayment') : endpoints.get('_get_hapi_webshop_order');
		const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);

		await useApi(webshopOrder, {method: 'PUT', body: {'status': 'otkazano'}}, {lang: false})
		.then(async (res) => {
			if(res.success) {
				orderSuccess.value = 1;
				newPayment.value = null;
				newPaymentOptions.value = null;
				newPaymentId.value = 0;
				newPaymentCard.value = 0;
				newPaymentInstallment.value = 1;
				if(additionalPaymentRoute.value == 1) {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_failed_payment'),
						query: {order_identificator: id_code, webshopadditionalpayment: '1'}
					});
				} else {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_failed_payment'),
						query: {order_identificator: id_code}
					});
				}
			}
		})

		checkoutLoading.value = false;
	}

	async function newPaymentFunction() {
		checkoutLoading.value = true;

		const id_code = (additionalPaymentRoute.value == 1) ? additionalPayment.value.cart.id + '-' + additionalPayment.value.cart.code : orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
		const webshopOrderId = (additionalPaymentRoute.value == 1) ? endpoints.get('_put_hapi_webshop_additionalpayment') : endpoints.get('_get_hapi_webshop_order');
		const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);

		await useApi(webshopOrder + '?new_payment=1', {method: 'GET'})
		.then(async (res) => {
			if(res.success) {
				orderSuccess.value = 1
				if(additionalPaymentRoute.value == 1) {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_payment_new'),
						query: {order_identificator: id_code, webshopadditionalpayment: '1'}
					});
					additionalPayment.value = res.data;
				} else {
					await navigateTo({
						path: apiRoutes.getAppUrl('webshop_payment_new'),
						query: {order_identificator: id_code}
					});
					orderData.value = res.data;
				}
			}
		})

		checkoutLoading.value = false;
	}
</script>

<style lang="less" scoped>
	* {
		--sideOffset: 40px;
	}
	@media (max-width: @t) {
		* {
			--sideOffset: 25px;
		}
	}
	@media (max-width: @m) {
		* {
			--sideOffset: 20px;
		}
		.btn { height: 54px; font-size: 16px; line-height: 1; }
		.btn-icon-arrow > span:first-child:before { top: 4px; font-size: 9px; }
	}
	.cart-box{
		width: 395px; flex-shrink: 0; background: @white; border: 1px solid @borderColor; box-shadow: 0 0 18px 0 rgba(120,145,169,0.18); position: sticky; top: 85px; font-size: 15px;

		@media (max-width: @t){width: 360px;}
		@media (max-width: @m){width: 100%; font-size: 15px;}
	}
	.cart-box-body{
		padding: 30px var(--sideOffset);
		@media (max-width: @m){padding-block: 20px;}
	}
	.cart-box-id{
		display: grid; grid-template-columns: repeat(2, 1fr);
		span{flex-grow: 1; text-align: right;}
	}
	.cart-box-totals{
		display: grid; grid-template-columns: repeat(2, 1fr); margin-top: 10px; padding: 10px 0; border-top: 1px solid @borderColor; border-bottom: 1px solid @borderColor; font-weight: 600;
		span{flex-grow: 1; text-align: right;}
	}
	.cart-box-note{margin-top: 15px; font-size: 13px; color: @inputTextColor; position: relative;}
	.btn-cart-box{
		margin-top: 17px; width: 100%;
		&:hover .wc-box-btn-note{opacity: 1; visibility: visible; z-index: 11;}

		@media (max-width: @m){height: 54px; font-size: 16px; line-height: 1;}
	}
	.wc-box-btn-note{
		padding: 15px 20px 15px 50px; background: @white; border: 1px solid @red2; font-size: 14px; color: @textColor; text-align: left; position: absolute; top: 100%; left: -1px; right: -1px; opacity: 0; visibility: hidden; z-index: -11;
		&:before{.icon-available-last(); font: 18px/18px @fonti; color: @red2; position: absolute; right: unset; left: 20px; top: 16px; transform: none;}
		&:after{.pseudo(6px,6px); background: @white; border-left: 1px solid @red2; border-top: 1px solid @red2; top: -4px; left: 50%; transform: translateX(-50%) rotate(45deg);}

		@media (max-width: @t){display: none!important;}
	}
	.btn-canceled{
		color: @blue; cursor: pointer;
		span{
			padding: 0 0 0 15px;
			&:before{color: @blue; right: unset; left: 0; .rotate(90deg);}
		}

		@media (max-width: @m){
			height: 54px; font-size: 16px; line-height: 1;
			span:before{top: 4px;}
		}
	}
	.btn-canceled-order{
		cursor: pointer;
		&.btn-disabled{pointer-events: none;}
		span{
			padding: 0 0 0 30px;
			&:before{display: flex; align-items: center; justify-content: center; width: 19px; height: 19px; border: 1px solid @inputTextColor; border-radius: 100%; .icon-x(); font: 11px/1 @fonti; color: @inputTextColor; right: unset; top: 2px; left: 0; transform: none;}
		}

		@media (max-width: @m){
			height: 54px; font-size: 16px; line-height: 1;
			span:before{top: -2px!important;}
		}
	}
</style>
